export class ListJobTemplatesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "jobTemplates",
            "baseName": "jobTemplates",
            "type": "Array<JobTemplate>",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListJobTemplatesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
